import { Tooltip } from '@iwoca/orion';
import { FormattedDate, FormattedMessage } from 'react-intl';

import messages from './ApprovalHeader.messages';
import styles from './ApprovalHeader.module.css';
import ApprovalSubHeader from './approvalSubHeader/ApprovalSubHeader';
import InternationalisedName from '../../../multiLoanDashboard/dashboardComponents/InternationalisedName';
import { MoneyNoDecimals } from '../../../ui/moneyNoDecimals';
import { getTimeOutDate } from '../../MyOffers.helpers';
import { FormalOffer } from '../../MyOffers.types';

const ApprovalHeader = ({
    approvalStatusTimeOut,
    maxCashAmount
}: {
    approvalStatusTimeOut: ReturnType<typeof getTimeOutDate>;
    maxCashAmount: FormalOffer['max_amount'];
}) => (
    <div className={styles.header} data-testid="approval-header">
        <div
            className={styles.headerCustomerIntroduction}
            data-testid="headerLB"
        >
            <FormattedMessage
                {...messages.header}
                values={{
                    name: (
                        <span>
                            <InternationalisedName />
                        </span>
                    ),
                    offeredAmount: (
                        <span className={styles.headerBlue}>
                            <MoneyNoDecimals value={maxCashAmount} />
                        </span>
                    ),
                    timeoutDate: (
                        <span className={styles.headerBlue}>
                            <FormattedDate
                                value={new Date(approvalStatusTimeOut)}
                                day="2-digit"
                                month="long"
                                year="numeric"
                            />
                        </span>
                    ),
                    tooltip: (
                        <span className={styles.headerTooltip}>
                            <Tooltip
                                // @ts-expect-error
                                content={
                                    <FormattedMessage {...messages.tooltip} />
                                }
                            />
                        </span>
                    )
                }}
            />
        </div>
        <ApprovalSubHeader />
    </div>
);

// eslint-disable-next-line import/no-default-export
export default ApprovalHeader;
